/* tslint:disable */
/* eslint-disable */
/**
 * noco-server
 * noco-server
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { CompanyListFromJSON, CompanyListToJSON } from './CompanyList';
export function CreateCompanyListResponseDataFromJSON(json) {
    return CreateCompanyListResponseDataFromJSONTyped(json, false);
}
export function CreateCompanyListResponseDataFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) {
        return json;
    }
    return {
        companyList: !exists(json, 'company_list') ? undefined : CompanyListFromJSON(json['company_list'])
    };
}
export function CreateCompanyListResponseDataToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        company_list: CompanyListToJSON(value.companyList)
    };
}
